import DefinitionTooltip from 'components/DefinitionTooltip';

function PresetTooltip({ preset, presets, ...props }) {
    return (
        <DefinitionTooltip
            title={presets[preset].label}
            body={presets[preset].definition}
            mixpanelMeta={{ contentKey: preset }}
            {...props}
        />
    );
}

export default PresetTooltip;
